import AuthService from './auth'
import HashService from './hash'

export const authService = new AuthService()
export const hashService = new HashService()
